import type {MigratedPortalModule} from './migrated-portal-modules'
import {navigateToMigratedRouteOnNewPortal} from './navigate-to-migrated-route-on-new-portal'
import {PORTAL_MODULE_PREF_NAVIGATION} from './portal-module-pref-navigation-result'
import {resolveModuleIdFromPath} from './portal-module-prefs'
import type {SessionBridgeResult} from './session-bridge-result'

type ApplyPortalModulePrefNavigationInput = {
  module: MigratedPortalModule
  enabled: boolean
  pathname: string
  search: string
}

export type ApplyPortalModulePrefNavigationOutcome = {navigated: true} | {navigated: false; bridge?: SessionBridgeResult}

export function applyPortalModulePrefNavigation({
  module,
  enabled,
  pathname,
  search,
}: ApplyPortalModulePrefNavigationInput): ApplyPortalModulePrefNavigationOutcome {
  const currentModuleId = resolveModuleIdFromPath(pathname)
  if (currentModuleId !== module.id) {
    return {navigated: false}
  }

  if (!enabled) {
    return PORTAL_MODULE_PREF_NAVIGATION.skipped
  }

  const bridge = navigateToMigratedRouteOnNewPortal(pathname, search)
  if (bridge.ok) {
    return PORTAL_MODULE_PREF_NAVIGATION.navigated
  }

  return {navigated: false, bridge}
}
